import * as yup from 'yup';

const SymptomEditSchema = yup.object({
  status: yup.string().required('Name is required'),
  notes: yup.string().required('Notes is required'),
  icd10: yup.string(),
});

export { SymptomEditSchema };
